import { isNullOrWhiteSpace } from "Utils/String";
import { assertSuccessStatus } from "./Request";

export async function getImageAsBase64(url: string, type: string): Promise<string> {
  const response = await fetch(url);
  await assertSuccessStatus(response);
  const base64 = await response.text();
  if (isNullOrWhiteSpace(base64)) {
    return null;
  }
  return `data:${type};base64,${base64}`;
}
